@if (history | isLoaded) {
<k2-table [items]="history.current" [paginator]="currentPaginator">
  <ng-container header><h2>Active logins</h2></ng-container>
  <table>
    <thead>
      <tr>
        <th>OS</th>
        <th class="p2">Browser</th>
        <th>IP Address</th>
        <th class="text-center">Country</th>
        @if (loginType === 1770) {
        <th class="options">Options</th>
        }
      </tr>
    </thead>
    <tbody>
      @for ( session of history.current | paginate: currentPaginator | async ;
      track session) {
      <tr>
        <td>{{ session.os }}</td>
        <td class="p2">{{ session.browser }}</td>
        <td>{{ session.ip }}</td>
        <td class="text-center">
          @if (session.country_name) {
          <country-flag
            [code]="session.country"
            [tooltip]="session.country_name"
          ></country-flag>
          } @if (session.country_name == null) {
          <empty>Unknown</empty>
          }
        </td>
        @if (loginType === 1770) {
        <td class="options">
          <a (click)="deleteSession(session)">
            <action type="remove">logout</action>
          </a>
        </td>
        }
      </tr>
      }
    </tbody>
  </table>
  <no-data ifNothing>{{ userName }} is not currently logged in.</no-data>
</k2-table>
<k2-table [items]="history.history" [paginator]="historyPaginator">
  <ng-container header>
    <h2>Last {{ history.history.length }} successful logins</h2>
  </ng-container>
  <table>
    <thead>
      <tr>
        <th>Date</th>
        <th>OS</th>
        <th class="p2">Browser</th>
        <th>IP Address</th>
        <th class="text-center">Country</th>
      </tr>
    </thead>
    <tbody>
      @for ( session of history.history | paginate: historyPaginator | async ;
      track session) {
      <tr>
        <td><date-time [iso]="session.time"></date-time></td>
        <td>{{ session.os }}</td>
        <td class="p2">{{ session.browser }}</td>
        <td>{{ session.ip }}</td>
        <td class="text-center">
          @if (session.country_name) {
          <country-flag
            [code]="session.country"
            [tooltip]="session.country_name"
          ></country-flag>
          } @if (session.country_name == null) {
          <empty>Unknown</empty>
          }
        </td>
      </tr>
      }
    </tbody>
  </table>
  <no-data ifNothing>{{ userName }} has never logged in.</no-data>
</k2-table>
}
